import { useMutation } from "@tanstack/react-query";
import http from "../../utils/http-common";

export function useUploadJson() {
  const uploadJson = async (payload: any) => {
    const response = await http.post("/suite/json", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  };

  return useMutation({
    mutationFn: uploadJson,
  });
}
